import * as tslib_1 from "tslib";
import classnames from 'classnames';
import { m } from '../hyperscript';
var combineClasses = function () {
    var attrs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        attrs[_i] = arguments[_i];
    }
    return attrs.reduce(function (res, attr) { return (tslib_1.__assign({}, res, { className: classnames(res && res.className, res && res.class, attr && attr.className, attr && attr.class) })); }, {});
};
export var style = function (from, add) {
    var extend = add || from;
    if (typeof extend !== 'string')
        throw 'String selector expected';
    var vnode = m(extend);
    var as = vnode.tag, parsed = vnode.attrs;
    if (typeof from === 'string' && add)
        return style(function (_a) {
            var children = _a.children, attrs = tslib_1.__rest(_a, ["children"]);
            return m(from, attrs, children);
        }, add);
    return typeof from !== 'string'
        ? function (_a) {
            var children = _a.children, attrs = tslib_1.__rest(_a, ["children"]);
            return m(from, tslib_1.__assign({ as: as }, combineClasses(parsed, attrs)), children);
        }
        : function (_a) {
            var children = _a.children, attrs = tslib_1.__rest(_a, ["children"]);
            return m((attrs.as || as), tslib_1.__assign({}, combineClasses(parsed, attrs)), children);
        };
};
